import { render, staticRenderFns } from "./CommunityIndicator.vue?vue&type=template&id=62628c09&scoped=true&"
import script from "./CommunityIndicator.vue?vue&type=script&lang=js&"
export * from "./CommunityIndicator.vue?vue&type=script&lang=js&"
import style0 from "./CommunityIndicator.vue?vue&type=style&index=0&id=62628c09&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62628c09",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VChip,VCol,VRow})
